import { render, staticRenderFns } from "./group.vue?vue&type=template&id=72f319a0&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=72f319a0&prod&scoped=true&lang=css"
import style1 from "./group.vue?vue&type=style&index=1&id=72f319a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f319a0",
  null
  
)

export default component.exports